module.exports = __webpack_public_path__ + "static/media/cleanup.8f8cc05e.svg";